import React from 'react';
import { Fieldset, Input, PriceString } from '@fourthwall/components';
import { useTierContext } from '../../hooks/useTierContext';
import { FormFields } from '../../providers/TierProvider/types';
import * as S from './styled';
export const MonthDiscount = () => {
    const { form, annualDiscount, isLoading } = useTierContext();
    if (form.values.discountType !== 'oneTime')
        return null;
    if (form.values.price && parseFloat(form.values.price) === 0)
        return null;
    if (!form.values.discount)
        return null;
    const renderMonthDiscountInfo = () => {
        if (!form.values.price ||
            !form.values.monthDiscount ||
            parseInt(form.values.monthDiscount) > 100 ||
            parseInt(form.values.monthDiscount) < 0)
            return null;
        return (React.createElement(S.DiscountInfo, null,
            React.createElement(S.DiscountInfoLabel, null, "First month"),
            React.createElement(PriceString, { value: form.values.price
                    ? Math.floor((parseFloat(form.values.price) -
                        parseFloat(form.values.price) * (parseInt(form.values.monthDiscount) / 100)) *
                        100) / 100
                    : 0 })));
    };
    return (React.createElement(Fieldset.Row, { inner: true },
        React.createElement(S.Container, null,
            annualDiscount && React.createElement(S.DisountLabel, null, "Monthly membership"),
            React.createElement(S.DiscountInputContainer, null,
                React.createElement(Input, { label: "First month discount", type: "number", append: "%", hideSpinner: true, disabled: isLoading, ...form.getFieldProps(FormFields.monthDiscount) }),
                renderMonthDiscountInfo()))));
};
